import * as React from 'react'

import { observer } from 'mobx-react'

import { SimpleChargebeeSubscription } from 'modules/billing/lib/prices'

import CloseReasonModal from './CloseReasonModal'
import FullScreenStep from './FullScreenStep'
import { Step } from './types'

interface Props {
  planConfig: SimpleChargebeeSubscription[]
  onClose: () => void
  isF25Pricing: boolean
}

const PaymentGateway = ({ planConfig, onClose, isF25Pricing = false }: Props) => {
  const [step, setStep] = React.useState<Step>('payment-gateway')

  return (
    <>
      {step === 'payment-gateway' && (
        <FullScreenStep planConfig={planConfig} setStep={setStep} isF25Pricing={isF25Pricing} />
      )}
      {step === 'close-reason' && <CloseReasonModal onClose={onClose} />}
    </>
  )
}

export default observer(PaymentGateway)
